import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export const CustomToast = withReactContent(
  Swal.mixin({
    toast: true,
    position: "top",
    customClass: {
      popup: "toast",
    },
    showConfirmButton: false,
    timer: 4000,
    timerProgressBar: false,
  })
);

export const ErrorToast = CustomToast.mixin({
  timer: 2500,
  icon: "error",
  iconColor: "white",
  customClass: { popup: "error" },
});

export const SuccessToast = CustomToast.mixin({
  timer: 2500,
  icon: "success",
  iconColor: "white",
  customClass: { popup: "success" },
});
